'use client';
import React, { useState } from 'react';
import { Pencil, X } from 'lucide-react';
export default function Forums() {
  const [forums, setForums] = useState([
    {
      name: 'General',
      displayOrder: 5,
      createdOn: '02/11/2025 10:34:46 PM',
    },
  ]);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [showForumModal, setShowForumModal] = useState(false);
  const [groupForm, setGroupForm] = useState({ name: '', displayOrder: 1 });
  const [forumForm, setForumForm] = useState({
    group: 'General',
    name: '',
    description: '',
    displayOrder: 1,
  });
  const addGroup = () => {
    alert(`Forum Group "${groupForm.name}" added successfully!`);
    setGroupForm({ name: '', displayOrder: 1 });
    setShowGroupModal(false);
  };
  const addForum = () => {
    const newForum = {
      name: forumForm.name,
      displayOrder: forumForm.displayOrder,
      createdOn: new Date().toLocaleString(),
    };
    setForums([...forums, newForum]);
    setForumForm({
      group: 'General',
      name: '',
      description: '',
      displayOrder: 1,
    });
    setShowForumModal(false);
  };
  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        <h1 className="text-3xl font-semibold text-gray-800">Forums</h1>
        <div className="mt-4 md:mt-0 flex flex-wrap gap-2">
          <button
            onClick={() => setShowGroupModal(true)}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-md shadow"
          >
            Add New Forum Group
          </button>
          <button
            onClick={() => setShowForumModal(true)}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-md shadow"
          >
            Add New Forum
          </button>
        </div>
      </div>
      {/* Info */}
      <p className="text-gray-700 mb-4">
        Learn more about{' '}
        <a href="#" className="text-blue-600 hover:underline">
          forums
        </a>
      </p>
      {/* Table */}
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-gray-700">
            <thead className="bg-gray-100 border-b">
              <tr>
                <th className="px-4 py-3 text-left font-medium">Name</th>
                <th className="px-4 py-3 text-left font-medium">Display Order</th>
                <th className="px-4 py-3 text-left font-medium">Created on</th>
                <th className="px-4 py-3 text-left font-medium">Edit</th>
              </tr>
            </thead>
            <tbody>
              {forums.map((forum, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-3">{forum.name}</td>
                  <td className="px-4 py-3">{forum.displayOrder}</td>
                  <td className="px-4 py-3">{forum.createdOn}</td>
                  <td className="px-4 py-3">
                    <button className="flex items-center gap-1 text-blue-600 hover:text-blue-800">
                      <Pencil size={16} />
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between p-4 text-sm text-gray-600">
          <div className="flex items-center gap-2 mb-3 sm:mb-0">
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              Previous
            </button>
            <button className="px-3 py-1 bg-blue-600 text-white rounded">1</button>
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              Next
            </button>
          </div>
          <div className="flex items-center gap-2">
            <span>Show</span>
            <select className="border rounded px-2 py-1" defaultValue="15">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="25">25</option>
            </select>
            <span>items</span>
          </div>
        </div>
        {/* Footer */}
        <div className="px-4 py-2 text-center text-sm text-gray-500 border-t">
          {forums.length}–{forums.length} of {forums.length} items
        </div>
      </div>
      {/* Forum Group Modal */}
      {showGroupModal && (
        <Modal title="Add New Forum Group" onClose={() => setShowGroupModal(false)}>
          <BackLink text="back to forum group list" onClick={() => setShowGroupModal(false)} />
          <InputField
            label="Name"
            value={groupForm.name}
            onChange={(e) => setGroupForm({ ...groupForm, name: e.target.value })}
          />
          <InputField
            label="Display Order"
            type="number"
            value={groupForm.displayOrder}
            onChange={(e) => setGroupForm({ ...groupForm, displayOrder: parseInt(e.target.value) })}
          />
          <SaveButtons onSave={addGroup} />
        </Modal>
      )}
      {/* Forum Modal */}
      {showForumModal && (
        <Modal title="Add New Forum" onClose={() => setShowForumModal(false)}>
          <BackLink text="back to forum list" onClick={() => setShowForumModal(false)} />
          <SelectField
            label="Forum Group"
            options={['General']}
            value={forumForm.group}
            onChange={(e) => setForumForm({ ...forumForm, group: e.target.value })}
          />
          <InputField
            label="Name"
            value={forumForm.name}
            onChange={(e) => setForumForm({ ...forumForm, name: e.target.value })}
          />
          <TextAreaField
            label="Description"
            value={forumForm.description}
            onChange={(e) => setForumForm({ ...forumForm, description: e.target.value })}
          />
          <InputField
            label="Display Order"
            type="number"
            value={forumForm.displayOrder}
            onChange={(e) =>
              setForumForm({ ...forumForm, displayOrder: parseInt(e.target.value) })
            }
          />
          <SaveButtons onSave={addForum} />
        </Modal>
      )}
    </div>
  );
}
/* ------------------ Reusable Components ------------------ */
function Modal({ title, children, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-10 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl mx-4 p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <X size={20} />
        </button>
        <h2 className="text-xl font-semibold mb-4">{title}</h2>
        {children}
      </div>
    </div>
  );
}
function InputField({ label, type = 'text', value, onChange }) {
  return (
    <div className="mb-4">
      <label className="block font-medium mb-1 text-gray-700">{label}</label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        className="border rounded w-full px-3 py-2 focus:ring focus:ring-blue-300 outline-none"
      />
    </div>
  );
}
function TextAreaField({ label, value, onChange }) {
  return (
    <div className="mb-4">
      <label className="block font-medium mb-1 text-gray-700">{label}</label>
      <textarea
        rows="4"
        value={value}
        onChange={onChange}
        className="border rounded w-full px-3 py-2 focus:ring focus:ring-blue-300 outline-none"
      />
    </div>
  );
}
function SelectField({ label, options, value, onChange }) {
  return (
    <div className="mb-4">
      <label className="block font-medium mb-1 text-gray-700">{label}</label>
      <select
        value={value}
        onChange={onChange}
        className="border rounded w-full px-3 py-2 focus:ring focus:ring-blue-300 outline-none"
      >
        {options.map((opt, i) => (
          <option key={i}>{opt}</option>
        ))}
      </select>
    </div>
  );
}
function BackLink({ text, onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center text-blue-600 mb-4 hover:underline"
    >
      ← {text}
    </button>
  );
}
function SaveButtons({ onSave }) {
  return (
    <div className="flex justify-end gap-3 mt-4">
      <button
        onClick={onSave}
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
      >
        Save
      </button>
      <button
        onClick={onSave}
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
      >
        Save and Continue Edit
      </button>
    </div>
  );
}
